import React, { useCallback } from 'react';
import { Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { HEADER } from '../utils/constants';
import { scrollToTop } from '../utils';

const Header = () => {
  const navigate = useNavigate();

  const handleLogoClick = useCallback(() => {
    navigate('/');
    scrollToTop();
  }, [navigate]);

  return (
    <header className="header">
      <div className="header-content">
        <button
          className="logo"
          onClick={handleLogoClick}
          aria-label="Volver al inicio"
        >
          <Heart size={64} className="logo-icon" suppressHydrationWarning />
          <div className="title">
            <h1>{HEADER.title}</h1>
            <p className="subtitle">{HEADER.subtitle}</p>
          </div>
        </button>
      </div>
    </header>
  );
};

export default Header;
